// extracted by mini-css-extract-plugin
export default {"wrapper":"_108e699d"};